export enum IssueScore {
    one = 1,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten
}

export const getIssueScoreNameRu = (state: IssueScore) => {
    switch (state) {
        case IssueScore.one: return '1';
        case IssueScore.two: return '2, это невозможно';
        case IssueScore.three: return '3, хамство';
        case IssueScore.four: return '4, такое не должно повторится';
        case IssueScore.five: return '5, много чего поломано, так нельзя';
        case IssueScore.six: return '6, поломали но починили';
        case IssueScore.seven: return '8, чуть-чуть поломано, но не критично';
        case IssueScore.eight: return '8, хорошо!';
        case IssueScore.nine: return '9, почти отлично!';
        case IssueScore.ten: return '10, Отлично!';
    }
}